export default {
    computed: {
        availableErrors() {
            const allErrors = this.errors || []
            const selectedErrorId = this.complaint?.complaintErrorId
            const visibleErrors = allErrors.filter(error => error.isVisible === true)

            const available = [...visibleErrors]

            if (selectedErrorId) {
                const selectedError = allErrors.find(error => error.id === selectedErrorId)

                if (selectedError && selectedError.isVisible === false) {
                    const exists = available.some(e => e.id === selectedErrorId)

                    if (!exists) available.push(selectedError)
                }
            }

            return available
        },
    }
}
